import { initializeApp } from "firebase/app";
import { connectFirestoreEmulator, getFirestore } from "firebase/firestore";
import { connectAuthEmulator, getAuth } from "firebase/auth";
import { getAnalytics } from "firebase/analytics";
import { connectFunctionsEmulator, getFunctions } from "firebase/functions";
import { connectStorageEmulator, getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FB_API_KEY,
  authDomain: import.meta.env.VITE_FB_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FB_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FB_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FB_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FB_APP_ID,
  measurementId: import.meta.env.VITE_GA4_ID
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
export const db = getFirestore(app);
export const auth = getAuth(app);
export const functions = getFunctions(app, 'asia-east1');  // 指定 region 與 Firestore 一致
export const storage = getStorage(app);

const emulatorState = globalThis as typeof globalThis & { __jinxiaFirebaseEmulatorsConnected?: boolean };
if (import.meta.env.VITE_USE_FIREBASE_EMULATORS === 'true' && !emulatorState.__jinxiaFirebaseEmulatorsConnected) {
  connectAuthEmulator(auth, 'http://127.0.0.1:9099', { disableWarnings: true });
  connectFirestoreEmulator(db, '127.0.0.1', 8080);
  connectFunctionsEmulator(functions, '127.0.0.1', 5001);
  connectStorageEmulator(storage, '127.0.0.1', 9199);
  emulatorState.__jinxiaFirebaseEmulatorsConnected = true;
}

// Analytics should not contact Google from local development, emulators, or E2E.
// The production bundle initializes it only when a measurement ID is configured.
export const analytics = import.meta.env.PROD && firebaseConfig.measurementId
  ? getAnalytics(app)
  : null;



export default app;
